export const MEASUREMENT_TOOL_IDS = {
  line: "line",
  polyline: "polyline",
  rectangle: "rectangle",
  polygon: "polygon",
} as const;

export type MeasurementToolId =
  (typeof MEASUREMENT_TOOL_IDS)[keyof typeof MEASUREMENT_TOOL_IDS];

export const MEASUREMENT_TYPES = {
  LF: "LF",
  SQFT: "SQFT",
  CF: "CF",
} as const;

export type MeasurementUnit =
  (typeof MEASUREMENT_TYPES)[keyof typeof MEASUREMENT_TYPES];

export const MEASUREMENT_GEOMETRY_TYPES = {
  rect: "rect",
  poly: "poly",
} as const;

export type MeasurementGeometryType =
  (typeof MEASUREMENT_GEOMETRY_TYPES)[keyof typeof MEASUREMENT_GEOMETRY_TYPES];

export const MEASUREMENT_DRAW_RESULT_KINDS = {
  ignore: "ignore",
  append: "append",
  finalize: "finalize",
} as const;

export type MeasurementDrawResultKind =
  (typeof MEASUREMENT_DRAW_RESULT_KINDS)[keyof typeof MEASUREMENT_DRAW_RESULT_KINDS];
